import { Component } from '@angular/core';


@Component({
    moduleId: module.id,
    templateUrl: 'clientPayroll.html'

})
export class ClientPayrollComponent { }



// WEBPACK FOOTER //
// ./src/app/ClientPayroll/clientPayroll.component.ts